import React, { Component } from 'react';
import Axios from 'axios';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import './styles/avatar.css';
import authservice from '../Authentication/service/authservice';

class Avatar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dropdown: false,
            profilePhoto: '',
            isProfileUpdated: false,
            isAdmin: this.props.isAdmin,
            agency: false,
        }
        this._isMounted = false;
        this.dropdownRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        this._isMounted = true;
        this.getProfilePhoto();
        this.handlQualification()
        document.addEventListener("click", this.handleClickOutside, true);
        document.addEventListener("mousedown", this.handleClickOutside, true);
        window.addEventListener("scroll", this.handleScroll, true);
    }

    componentWillUnmount() {
        this._isMounted = false;
        document.removeEventListener("click", this.handleClickOutside, true);
        document.removeEventListener("mousedown", this.handleClickOutside);
        window.removeEventListener("scroll", this.handleScroll, true);
    }

    static getDerivedStateFromProps(props, state) {
        let update = {};
        if (props.isProfileUpdated !== state.isProfileUpdated) {
            update.isProfileUpdated = props.isProfileUpdated;
        }
        if (props.isAdmin !== state.isAdmin) {
            update.isAdmin = props.isAdmin;
        }
        return update;
    }

    componentDidUpdate(props, state) {
        if (props.isProfileUpdated !== this.state.isProfileUpdated) {
            this.props.setProfileUpdated(false);
            this._isMounted && this.setState({ isProfileUpdated: false })
            this.getProfilePhoto();
        }
    }
    getProfilePhoto() {
        const username = authservice.getCurrentUserName();
        //var image = new FormData();
        Axios.get(process.env.REACT_APP_BACKEND_URL + `/abmgr/user/get-profile-photo/${username}`)
            .then(response => {
                this._isMounted &&
                    this.setState({ profilePhoto: response.data })
            }).catch(error => {
                console.warn(error);
            })
    }


    handleClick = (e) => {
        e.preventDefault();
        if (this.state.isAdmin) {
            this.props.history.push('/admin-panel/manage-profile')
        } else {
            try {
                if (this.icon && this.icon.contains(e.target)) {
                    const toggle = !this.state.dropdown
                    this.setState({
                        dropdown: toggle
                    })
                    // if (toggle)
                    //     document.addEventListener("click", this.handleClick, false);
                    // else
                    //     document.removeEventListener("click", this.handleClick, false);
                } else {
                    this.setState({ dropdown: false })
                    document.removeEventListener("click", this.handleClick, false);
                }
            } catch (error) {
                this.setState({ dropdown: false })
                document.removeEventListener("click", this.handleClick, false);
            }
        }
    }

    handleClickOutside = (event) => {
        if (this.state.dropdown && this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
            this.setState({ dropdown: false });
        }
    };

    handleScroll = () => {
        if (this.state.dropdown) {
            this.setState({ dropdown: false });
        }
    };

    handlQualification = () => {
            const userId = authservice.getCurrentUserid()
            Axios.get(process.env.REACT_APP_BACKEND_URL + `/abmgr/user/get-content-approval-status/${userId}`)
                .then((response) => {
                    const agency = response.data.isAgency
                    this.setState({ agency: agency })
                })
                .catch((error) => {
                    console.error(error);
                });
        };

    render() {
        return (
            <div ref={icon => this.icon = icon}>
                {this.state.profilePhoto ?
                    <span className="">
                        <img src={process.env.REACT_APP_IMAGES_URL + this.state.profilePhoto} height="40" width="40" className="header-avatar" aria-hidden="true" onClick={this.handleClick} />
                    </span> : <i className="fa fa-user-circle-o fa-3x cursor" aria-hidden="true" onClick={this.handleClick} />}

                <div ref={this.dropdownRef}>{this.state.dropdown && (
                    <div className='menu-lists'>
                        <div className='arrow'></div>
                        <div className='inner-box'>
                            <ul>
                                <Link to="/manageprofile"><button className="btn avatar-dropdown-btn text-xs-center" onClick={() => this.setState({ dropdown: false })}>Manage Profile</button></Link>
                                <Link to="/manageposts"><button className="btn avatar-dropdown-btn text-xs-center" onClick={() => this.setState({ dropdown: false })}>Manage Posts</button></Link>
                                <Link to="/manageadvertisement"><button className="btn avatar-dropdown-btn text-xs-center" onClick={() => this.setState({ dropdown: false })}>Manage Ads</button> </Link>
                                {authservice.getAccountType() !== 'SUB_USER' ? <Link to="/managestaff"><button className="btn avatar-dropdown-btn text-xs-center" onClick={() => this.setState({ dropdown: false })}>Manage Staff</button></Link> : null}
                                {authservice.getAccountType() !== 'SUB_USER' ? <Link to="/qualification"><button className="btn avatar-dropdown-btn text-xs-center" onClick={() => this.setState({ dropdown: false })}>Qualification</button></Link> : null}
                                <Link to={`/categories/${authservice.getCurrentUserName()}`}><button className="btn avatar-dropdown-btn text-xs-center" onClick={() => this.setState({ dropdown: false })}>My Contents</button></Link>
                                <Link to={`/mart/${authservice.getCurrentUserName()}`}><button className="btn avatar-dropdown-btn text-xs-center" onClick={() => this.setState({ dropdown: false })}>My Mart</button></Link>
                                <Link to={`/orders`}><button className="btn avatar-dropdown-btn text-xs-center" onClick={() => this.setState({ dropdown: false })}>My Orders</button></Link>
                                {authservice.getAccountType() !== 'SUB_USER' ? <Link to="/viewreport"><button className="btn avatar-dropdown-btn text-xs-center" onClick={() => this.setState({ dropdown: false })}>View Report</button></Link> : null}
                                {this.state.agency === true ? <Link to={`/manageagency`}><button className="btn avatar-dropdown-btn text-xs-center" onClick={() => this.setState({ dropdown: false })}>Agency Report</button></Link> : null}
                            </ul>
                        </div>
                    </div>
                )}</div>
            </div>

        );
    }
}

const mapStateToProps = state => {
    return {
        isProfileUpdated: state.isProfileUpdated,
        isAdmin: state.isAdmin,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setProfileUpdated: (isProfileUpdated) => dispatch({ type: 'IS_PROFILE_UPDATED', isProfileUpdated: isProfileUpdated }),
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Avatar));